import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { getBackendUrl } from "./backendUrl";

const LOCAL_BACKEND = /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::8000)?(?=\/|$)/i;

/**
 * Several established screens build requests directly from
 * REACT_APP_BACKEND_URL and a few use relative /api URLs.  Configure Axios
 * once so native builds never resolve those URLs against the Android device's
 * localhost. External URLs are deliberately left untouched.
 */
export const configureApiClient = () => {
  if (!Capacitor.isNativePlatform()) return;

  axios.interceptors.request.use((config) => {
    const url = config.url;
    if (!url) return config;

    if (url.startsWith("/api/")) {
      config.url = `${getBackendUrl()}${url}`;
    } else if (LOCAL_BACKEND.test(url)) {
      config.url = url.replace(LOCAL_BACKEND, getBackendUrl());
    }

    return config;
  });
};
